import './style.css'

function App() {
  return (
    <div className="App body">
      <h1 className="name">Shresth Mamchand</h1>
      <p className='content'>Hey, I'm a Senior Software Engineer at <a className='link' href="https://apple.com">Apple Inc</a>. I enjoy working with javascript and crafting beautiful front-end experiences.

      </p>
      <p className='content'>
        <strong>Following are some of my projects and experiences.</strong>
        <br /><br />
        Can turn that pussy to a faucet!
      </p>
      <footer className="footer">
        <a href="https://github.com/shreskrrrth" target={"_blank"} rel='noreferrer' className='link'>Download CV</a>
      </footer>
    </div>
  );
}

export default App;
